import { ComponentRoute } from '@/classes'

const DealerCreditEntryRoutes = {
  DealerCreditEntryView: new ComponentRoute('/dealercreditentry', 'DealerCreditEntryView'),
  DealerCreditEntryAttachments: new ComponentRoute('attachments', 'DealerCreditEntryAttachments')
}

export default DealerCreditEntryRoutes